import React from "react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { i18n } from "../../../translate/i18n";

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: 12,
  fontSize: 12,
};

const cellStyle = {
  border: "1px solid #ddd",
  padding: "6px 8px",
};

const headerCellStyle = {
  ...cellStyle,
  background: "#f0f3f9",
  fontWeight: 700,
};

const rightCellStyle = {
  ...cellStyle,
  textAlign: "center",
};

const rightHeaderCellStyle = {
  ...headerCellStyle,
  textAlign: "center",
};

const formatDate = (dateString) => {
  if (!dateString) return "-";
  try {
    return format(new Date(`${dateString}T00:00:00`), "dd/MM/yyyy", { locale: ptBR });
  } catch {
    return "-";
  }
};

const UsageReportGeneralPrintTemplate = React.forwardRef(({ reportData }, ref) => {
  const generatedAt = format(new Date(), "dd/MM/yyyy HH:mm", { locale: ptBR });
  const contactMethods = reportData?.contactMethods || [];

  if (!reportData) {
    return <div ref={ref}>{i18n.t("usageReport.print.noData")}</div>;
  }

  return (
    <div ref={ref} style={{ padding: 16, color: "#111", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ margin: 0 }}>{i18n.t("usageReport.print.generalTitle")}</h2>
      <p style={{ margin: "6px 0 0 0", fontSize: 12 }}>
        {i18n.t("usageReport.periodLabel", {
          period: i18n.t("usageReport.periodRange", { from: formatDate(reportData?.period?.dateFrom), to: formatDate(reportData?.period?.dateTo) }),
        })}
      </p>
      <p style={{ margin: "2px 0 0 0", fontSize: 12 }}>{i18n.t("usageReport.generatedAt", { date: generatedAt })}</p>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={headerCellStyle}>{i18n.t("usageReport.columns.user")}</th>
            {contactMethods.map((methodLabel) => (
              <th key={`head-${methodLabel}`} style={rightHeaderCellStyle}>{methodLabel}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(reportData.users || []).map((user) => (
            <tr key={user.userId}>
              <td style={cellStyle}>{user.userName}</td>
              {contactMethods.map((methodLabel) => (
                <td key={`${user.userId}-${methodLabel}`} style={rightCellStyle}>{user.contactMethods?.[methodLabel] || 0}</td>
              ))}
            </tr>
          ))}
          <tr>
            <td style={{ ...headerCellStyle, fontWeight: 700 }}>{i18n.t("common.total")}</td>
            {contactMethods.map((methodLabel) => (
              <td key={`total-${methodLabel}`} style={rightHeaderCellStyle}>{reportData?.totals?.contactMethods?.[methodLabel] || 0}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
});

UsageReportGeneralPrintTemplate.displayName = "UsageReportGeneralPrintTemplate";

export default UsageReportGeneralPrintTemplate;
